var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"activity-detail-page"},[(_vm.data)?_c('activity-detail',{attrs:{"data":_vm.data}}):_vm._e(),_c('div',{staticClass:"back"},[_c('fm-btn',{on:{"click":_vm.back}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }